import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { debounceTime, Subject, tap } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GroupDetail,
} from 'src/app/interfaces/group.interface';
import { AlliedservicesService } from 'src/app/services/alliedservices.service';
import { FacilitatorserviceService } from 'src/app/services/facilitatorservice.service';
import { GroupService } from 'src/app/services/groupservice.service';
import { LIST_GROUPLIST_COLUMN } from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';
import { DetailAdvertisingComponent } from '../detail-advertising/detail-advertising.component';
import { EditgroupComponent } from '../editgroup/editgroup.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-list-group',
  templateUrl: './list-group.component.html',
  styleUrls: ['./list-group.component.scss'],
})
export class ListGroupComponent implements OnInit, OnDestroy {
  @Input() public organizationIndex: string;
  @ViewChild('confirmationDialog') confirmationDialog: TemplateRef<any>;
  private subs = new SubSink();
  private readonly searchSubject = new Subject<string | undefined>();
  public displayedColumns: string[] = LIST_GROUPLIST_COLUMN;
  public dataSource = new MatTableDataSource<any>();
  public saveList: GroupDetail[] = [];
  public statusDetail: RequestStatus = 'init';

  public search: string = '';
  public page = 1;
  public pageSize: number = 10;
  public pageIndex: number = 0;
  public pageEvent: PageEvent;

  public length = 0;
  public sortField: string = 'names';
  public sortDirection: string = 'asc';
  public status: string = 'all';
  confirmationDialogRef: MatDialogRef<any, any>;
  selectedForDeletion: string;

  constructor(
    private rotuer: Router,
    private groupService: GroupService,
    private aliedService: AlliedservicesService,
    private facilitatorService: FacilitatorserviceService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.subs.sink = this.searchSubject
    .pipe(debounceTime(300))
    .subscribe((searchTerm: string | undefined) => {
      this.search = searchTerm || '';
      this.loadData();
    });

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  sortData(sort: Sort) {
    //this.statusDetail = 'loading';
    this.sortField = sort.active;
    this.sortDirection = sort.direction;
    this.loadData();
  }

  openConfirmDialog(group: any) {
    this.selectedForDeletion = group.group_name;
    this.confirmationDialogRef = this.dialog.open(this.confirmationDialog, {
      width: '300px'
    });

    this.confirmationDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteGroup(group);
      }
    });
  }

  openEditDialog(group: any) {
    const dialogRef = this.dialog.open(EditgroupComponent, {
      width: '450px',
      height: '465px',
      disableClose: true,
      data: {
        fields: group,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadData();
    });
  }

  deleteGroup(group: any): void {
    this.subs.sink = this.groupService.deleteGroup(group._id).subscribe({
      next: (v) => console.log(v),
      error: (e) => {
        const errorMessage = this.extractErrorMessage(e);
        if (errorMessage) {
          this._snackBar.open(errorMessage, 'Cerrar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
        } else {
          this._snackBar.open('Error al intentar borrar', 'Cerrar', {
            duration: 1500,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });

        }
        console.error(e);
      },
      complete: () => this.loadData()
    });
  }

  public onSearchQueryInput(event: Event): void {
    const searchQuery = (event.target as HTMLInputElement).value;
    this.pageIndex = 0; // Reset to the first page on search
    this.searchSubject.next(searchQuery?.trim());
  }

  private loadData() {
    this.subs.sink = this.groupService.groupList(this.organizationIndex, this.pageIndex, this.pageSize, this.sortField, this.sortDirection, this.search)
      .pipe(tap(() => (this.statusDetail = 'success')))
      .subscribe((rta: any) => {
        this.dataSource.data = rta.groups;
        this.length = rta.totalElements;
      });
  }

  public handlePageEvent(ev: PageEvent): void {
    this.statusDetail = 'loading';
    this.pageIndex = ev.pageIndex + 1;
    this.pageSize = ev.pageSize;

    this.loadData();
    this.statusDetail = 'success';
  }

  public goToDetails(id: string): void {
    this.rotuer.navigate([`pages/userdash/group/${id}`]);
  }

  onCancel(): void {
    this.confirmationDialogRef.close(false);
  }

  onConfirm(): void {
    this.confirmationDialogRef.close(true);
  }

  public calculateStatus(initDate: Date, finalDate: Date): string {
    const todayDate = new Date();
    const startDate = new Date(initDate);
    const endDate = new Date(finalDate);
    if (startDate > todayDate && endDate >= todayDate) {
      return 'Próximamente';
    } else if (startDate <= todayDate && endDate >= todayDate) {
      return 'Activo';
    } else {
      return 'Inactivo';
    }
  }

  public openGroupAdvertising(nameGroup: string) {
    const dialogRef = this.dialog.open(DetailAdvertisingComponent, {
      width: '456px',
      height: '206px',
      disableClose: true,
      data: {
        nameGroup: nameGroup,
      },
    });
  }

  public transformDate(value: string): any {
    let newDateSplit = value.split('/');
    let newDate = new Date(
      `${newDateSplit[2]} / ${newDateSplit[0]}/${newDateSplit[1]}`
    ).getTime();
    return newDate;
  }

  extractErrorMessage(response: HttpErrorResponse): string | null {
    try {
      // Check if response has error property and errors array
      if (response?.error?.errors && response?.error?.errors?.length > 0) {
        // Return the first error message
        return response.error.errors[0].message;
      }
      return null; // Return null if no error message is found
    } catch (error) {
      console.error('Error extracting message:', error);
      return null;
    }
  }

}
